import { ItiHttpService } from "@/iti-core-react/services/iti-http-service";
import { API } from "../api";
import { GlossaryV2Dto } from "../dtos/glossary-v2-dto";

export const RecycleGlossaryService = {
	// Obtiene los glosarios eliminados paginados
	async getDeletedGlossaries(): Promise<GlossaryV2Dto[]> {
		const res = await ItiHttpService.get(API.governance.glossariesDeleted);
		return res;
	},

	// Restaura un glosario eliminado
	async restoreGlossary(id: string): Promise<void> {
		return await ItiHttpService.put(
			`${API.governance.glossariesv2}/${id}/restore`,
			{},
			true,
			false,
			true,
		);
	},

	// Elimina permanentemente un glosario
	async permanentDeleteGlossary(id: string): Promise<void> {
		return await ItiHttpService.delete(
			`${API.governance.glossariesv2}/${id}?option=PHYSICAL`,
			null,
			true,
			false,
			true,
		);
	},
};
